import { defineMessages } from 'react-intl';

export default defineMessages({
  back: {
    id: 'cboard.components.BackButton.back',
    defaultMessage: 'Go back'
  }
});
